module.exports = __webpack_public_path__ + "static/media/cc_icon-dinersclub.d1a48044.svg";